import { createContext } from 'react';
export const TableContext = /*#__PURE__*/createContext({
  stackable: false,
  warningDisabled: false
});
export default TableContext;